export const START_COURSE = "START_COURSE"
export const START_COURSE_SUCCESS = "START_COURSE_SUCCESS"
export const START_COURSE_CLEAN = "START_COURSE_CLEAN"
export const START_COURSE_ERROR = "START_COURSE_ERROR"
